export default __webpack_public_path__ + "static/media/ice-mobility-thumbnail.fcc07ac0.png";